module.exports = __webpack_public_path__ + "static/media/Swashakthi-SHG-Blog-3.aee8cdd8.webp";